import React from 'react';
import { withRouter } from 'react-router-dom';
import CONSTANT from '../../constant';
import Loader from '../../component/common/Loader';
import {
    saveKpiReport,
    updateKpiReport,
    getReportingAssessment,
    getKpiTaskGrade,
    getPersonalAttributeMasterList,
    getPersonalAttributeGrade,
    getReviewingAssessment,
    getAcceptingAssessment,
} from '../../actions/AppraisalCycleAction';
import { formatDateDDMMYY } from '../../utils';

const TYPE_LABELS: any = {
    hr:        { label: 'Employee KPI Report',      icon: 'fa-id-card-o',      color: 'text-info'    },
    reporting: { label: 'Reporting Manager',        icon: 'fa-user',           color: 'text-primary' },
    reviewing: { label: 'Reviewing Manager',        icon: 'fa-users',          color: 'text-warning' },
    accepting: { label: 'Accepting Authority',      icon: 'fa-check-square-o', color: 'text-success' },
};

const ROMAN_LABELS = ['i)','ii)','iii)','iv)','v)','vi)','vii)','viii)','ix)','x)'];
const ROMAN = ['i', 'ii', 'iii', 'iv', 'v', 'vi', 'vii', 'viii', 'ix', 'x'];

const INTEGRITY_LABELS: any = {
    beyond_doubt: 'Beyond doubt',
    doubtful: 'Integrity is doubtful (secret note attached)',
    nothing_adverse: 'Nothing adverse received',
};

const DEFAULT_TASKS = [
    { id: 1, particular: 'i)',    taskDescription: '', weightage: '', deliverables: '', achievement: '' },
    { id: 2, particular: 'ii)',   taskDescription: '', weightage: '', deliverables: '', achievement: '' },
    { id: 3, particular: 'iii)',  taskDescription: '', weightage: '', deliverables: '', achievement: '' },
    { id: 4, particular: 'iv)',   taskDescription: '', weightage: '', deliverables: '', achievement: '' },
    { id: 5, particular: 'v)',    taskDescription: '', weightage: '', deliverables: '', achievement: '' },
];

class HrReportDetail extends React.Component<any, any> {
    constructor(props: any) {
        super(props);

        const locationState = props.location?.state || {};

        this.state = {
            showLoader: false,
            employeeCode: locationState.employeeCode || '',
            employeeNumber: locationState.employeeNumber || '',
            type: locationState.type || '',
            selectedRecord: locationState.selectedRecord || null,

            isMouApplicable: locationState.isMouApplicable || false,
            kpiReportId: locationState.kpiReportId || null,

            mouTaskId: locationState.mouTaskId || null,
            mouTaskDescription: locationState.mouTaskDescription || '',
            mouWeightage: locationState.mouWeightage || '',
            mouDeliverables: locationState.mouDeliverables || '',
            mouAchievement: locationState.mouAchievement || '',

            otherKeyTasks: locationState.otherKeyTasks || DEFAULT_TASKS.map(t => ({ ...t })),

            // Manager report data
            reportingAssessment: null,
            reportingKpiGrades: null,
            reportingAttrGrades: [],
            reviewingAssessment: null,
            reviewingKpiGrades: null,
            reviewingAttrGrades: [],
            acceptingAssessment: null,
            personalAttributeMasters: [],
        };
    }

    componentDidMount() {
        window.scrollTo(0, 0);
        const { type, kpiReportId } = this.state;
        document.title = `${TYPE_LABELS[type]?.label || 'Report'} - ${CONSTANT.organisation.name}`;

        if (!this.state.selectedRecord) {
            this.props.history.replace(CONSTANT.component.hrReportDetailList.url);
            return;
        }

        if (type !== 'hr' && kpiReportId) {
            this.loadManagerData();
        }
    }

    loadManagerData = () => {
        const { type, kpiReportId } = this.state;
        this.setState({ showLoader: true });

        const promises: Promise<any>[] = [];

        if (type === 'reporting') {
            promises.push(
                getReportingAssessment({ kpiReportId }).then((res: any) => {
                    this.setState({ reportingAssessment: res?.result || res || null });
                }),
                getKpiTaskGrade({ kpiReportId, gradedByRole: 'reporting' }).then((res: any) => {
                    const resData = res?.result || res;
                    const grades = resData?.grades || (Array.isArray(resData) ? resData : []);
                    this.setState({ reportingKpiGrades: grades });
                }),
                getPersonalAttributeMasterList().then((res: any) => {
                    const masters = res?.result || res || [];
                    const sorted = [...masters].sort((a: any, b: any) => (a.sort_order || 0) - (b.sort_order || 0));
                    this.setState({ personalAttributeMasters: sorted });
                }),
                getPersonalAttributeGrade({ kpiReportId, gradedByRole: 'reporting' }).then((res: any) => {
                    const data = res?.result || res;
                    const grades = data?.grades || (Array.isArray(data) ? data : []);
                    this.setState({ reportingAttrGrades: grades });
                }),
            );
        } else if (type === 'reviewing') {
            promises.push(
                getReviewingAssessment({ kpiReportId }).then((res: any) => {
                    this.setState({ reviewingAssessment: res?.result || res || null });
                }),
                getKpiTaskGrade({ kpiReportId, gradedByRole: 'reviewing' }).then((res: any) => {
                    const resData = res?.result || res;
                    const grades = resData?.grades || (Array.isArray(resData) ? resData : []);
                    this.setState({ reviewingKpiGrades: grades });
                }),
                getPersonalAttributeMasterList().then((res: any) => {
                    const masters = res?.result || res || [];
                    const sorted = [...masters].sort((a: any, b: any) => (a.sort_order || 0) - (b.sort_order || 0));
                    this.setState({ personalAttributeMasters: sorted });
                }),
                getPersonalAttributeGrade({ kpiReportId, gradedByRole: 'reviewing' }).then((res: any) => {
                    const data = res?.result || res;
                    this.setState({ reviewingAttrGrades: data?.grades || (Array.isArray(data) ? data : []) });
                }),
            );
        } else if (type === 'accepting') {
            promises.push(
                getAcceptingAssessment({ kpiReportId }).then((res: any) => {
                    this.setState({ acceptingAssessment: res?.result || res || null });
                }),
                getKpiTaskGrade({ kpiReportId, gradedByRole: 'reporting' }).then((res: any) => {
                    const resData = res?.result || res;
                    const grades = resData?.grades || (Array.isArray(resData) ? resData : []);
                    this.setState({ reportingKpiGrades: grades });
                }),
                getKpiTaskGrade({ kpiReportId, gradedByRole: 'reviewing' }).then((res: any) => {
                    const resData = res?.result || res;
                    const grades = resData?.grades || (Array.isArray(resData) ? resData : []);
                    this.setState({ reviewingKpiGrades: grades });
                }),
                getPersonalAttributeMasterList().then((res: any) => {
                    const masters = res?.result || res || [];
                    const sorted = [...masters].sort((a: any, b: any) => (a.sort_order || 0) - (b.sort_order || 0));
                    this.setState({ personalAttributeMasters: sorted });
                }),
                getPersonalAttributeGrade({ kpiReportId, gradedByRole: 'reporting' }).then((res: any) => {
                    const data = res?.result || res;
                    this.setState({ reportingAttrGrades: data?.grades || (Array.isArray(data) ? data : []) });
                }),
                getPersonalAttributeGrade({ kpiReportId, gradedByRole: 'reviewing' }).then((res: any) => {
                    const data = res?.result || res;
                    this.setState({ reviewingAttrGrades: data?.grades || (Array.isArray(data) ? data : []) });
                }),
            );
        }

        Promise.all(promises).finally(() => {
            this.setState({ showLoader: false });
        });
    };

    // ── HR KPI Report methods ──
    handleOtherTaskChange = (index: number, field: string, value: string) => {
        const updated = [...this.state.otherKeyTasks];
        if (field === 'weightage') {
            const maxTotal = this.state.isMouApplicable ? 55 : 75;
            const otherSum = updated.reduce((sum: number, item: any, i: number) =>
                i === index ? sum : sum + (parseFloat(item.weightage) || 0), 0);
            const newVal = parseFloat(value) || 0;
            if (value !== '' && (otherSum + newVal) > maxTotal) {
                alert(`Other tasks weightage sum cannot exceed ${maxTotal}`);
                return;
            }
        }
        updated[index][field] = value;
        this.setState({ otherKeyTasks: updated });
    };

    onTextChange = (e: any) => {
        const { name, value } = e.target;
        this.setState({ [name]: value });
    };

    addRow = () => {
        const { otherKeyTasks } = this.state;
        if (otherKeyTasks.length >= 10) return;
        const nextIndex = otherKeyTasks.length;
        this.setState({
            otherKeyTasks: [
                ...otherKeyTasks,
                { id: Date.now(), particular: ROMAN_LABELS[nextIndex], taskDescription: '', weightage: '', deliverables: '', achievement: '' },
            ],
        });
    };

    removeRow = (index: number) => {
        if (index < 5) return;
        const updated = this.state.otherKeyTasks
            .filter((_: any, i: number) => i !== index)
            .map((row: any, i: number) => ({ ...row, particular: ROMAN_LABELS[i] }));
        this.setState({ otherKeyTasks: updated });
    };

    getTotalWeightage = () =>
        this.state.otherKeyTasks.reduce((sum: number, item: any) => sum + (parseFloat(item.weightage) || 0), 0);
    getMouWeightage = () => (this.state.isMouApplicable ? (parseFloat(this.state.mouWeightage) || 0) : 0);
    getGrandTotal = () => this.getMouWeightage() + this.getTotalWeightage();

    onSubmit = (e: any) => {
        e.preventDefault();
        this.setState({ showLoader: true });

        const { kpiReportId, selectedRecord, isMouApplicable, mouTaskDescription, mouWeightage, mouDeliverables, mouAchievement, otherKeyTasks } = this.state;
        const tasks: any[] = [];

        if (isMouApplicable) {
            tasks.push({ particular: '*)', taskDescription: mouTaskDescription, weightage: parseFloat(mouWeightage) || 0, deliverables: mouDeliverables, achievement: mouAchievement });
        }
        otherKeyTasks.forEach((t: any) => {
            tasks.push({ particular: t.particular, taskDescription: t.taskDescription, weightage: t.weightage || null, deliverables: t.deliverables, achievement: t.achievement });
        });

        if (kpiReportId) {
            updateKpiReport({ kpiReportId, isMouApplicable, tasks }).then((res: any) => {
                this.setState({ showLoader: false });
                if (res?.status === CONSTANT.static.apiStatus.success) alert('KPI report updated successfully!');
            });
        } else {
            saveKpiReport({ appraisalCycleId: selectedRecord?.cycle?.id, effectiveFrom: selectedRecord?.startDate, employeeCode: this.state.employeeCode, isMouApplicable, reportType: this.state.type, tasks }).then((res: any) => {
                this.setState({ showLoader: false });
                if (res?.status === CONSTANT.static.apiStatus.success) {
                    this.setState({ kpiReportId: res.result?.kpiReportId });
                    alert('KPI report saved successfully!');
                }
            });
        }
    };

    // ── Helper: build grade map from array ──
    buildGradeMap = (grades: any[]) => {
        const map: any = {};
        if (Array.isArray(grades)) {
            grades.forEach((g: any) => { map[g.kpi_task_id] = g; });
        }
        return map;
    };

    buildAttrGradeMap = (grades: any[]) => {
        const map: any = {};
        if (Array.isArray(grades)) {
            grades.forEach((g: any) => { map[g.attribute_master_id] = g; });
        }
        return map;
    };

    // ── Render: Reporting Manager View ──
    renderReportingView = () => {
        const { reportingAssessment, reportingKpiGrades, reportingAttrGrades, personalAttributeMasters, otherKeyTasks, isMouApplicable } = this.state;

        const gradeMap = this.buildGradeMap(reportingKpiGrades);
        const attrGradeMap = this.buildAttrGradeMap(reportingAttrGrades);

        const mouWeightage = parseFloat(this.state.mouWeightage) || 0;

        // MoU grade lookup
        const mouGrade = this.state.mouTaskId ? gradeMap[this.state.mouTaskId] : null;
        const mouGradeVal = mouGrade ? parseFloat(mouGrade.absolute_grade) || 0 : 0;
        const mouWeightedGrade = mouGrade ? parseFloat(mouGrade.weighted_grade) || 0 : 0;

        const tasksWithGrades = otherKeyTasks.map((t: any) => {
            const grade = gradeMap[t.id];
            return {
                ...t,
                absoluteGrade: grade ? String(grade.absolute_grade || '') : '',
                weightedGrade: grade ? parseFloat(grade.weighted_grade) || 0 : 0,
            };
        });

        const tasksTotal = tasksWithGrades.reduce((sum: number, t: any) => sum + (t.weightedGrade || 0), 0);
        const grandTotal = mouWeightedGrade + tasksTotal;

        const attrTotal = personalAttributeMasters.reduce((sum: number, m: any) => {
            const g = attrGradeMap[m.id];
            return sum + (g ? parseFloat(g.grade) || 0 : 0);
        }, 0);

        return (
            <div>
                {/* Section 1: Assessment Questions */}
                {reportingAssessment && (
                    <div className="mb-4">
                        <h5 className="fw-bold border-bottom pb-2 mb-3">Appraisal of the Reporting Authority</h5>

                        <div className="row mb-3">
                            <div className="col-md-6">
                                <label className="form-label fw-semibold">1. Agreement with accomplishments of work plan</label>
                                <p className="form-control bg-light" style={{ minHeight: '42px', height: 'auto', whiteSpace: 'pre-wrap', wordBreak: 'break-word' }}>{reportingAssessment.agree_accomplishments || <span className="text-muted fst-italic">Not filled</span>}</p>
                            </div>
                            <div className="col-md-6">
                                <label className="form-label fw-semibold">2. Comments on exceptional contribution</label>
                                <p className="form-control bg-light" style={{ minHeight: '42px', height: 'auto', whiteSpace: 'pre-wrap', wordBreak: 'break-word' }}>{reportingAssessment.exceptional_contribution_comment || <span className="text-muted fst-italic">Not filled</span>}</p>
                            </div>
                        </div>
                        <div className="row mb-3">
                            <div className="col-md-6">
                                <label className="form-label fw-semibold">3. Significant shortfall in achieving targets</label>
                                <p className="form-control bg-light" style={{ minHeight: '42px', height: 'auto', whiteSpace: 'pre-wrap', wordBreak: 'break-word' }}>{reportingAssessment.significant_shortfall || <span className="text-muted fst-italic">Not filled</span>}</p>
                            </div>
                            <div className="col-md-6">
                                <label className="form-label fw-semibold">4. Agreement with constraints mentioned</label>
                                <p className="form-control bg-light" style={{ minHeight: '42px', height: 'auto', whiteSpace: 'pre-wrap', wordBreak: 'break-word' }}>{reportingAssessment.agree_constraints || <span className="text-muted fst-italic">Not filled</span>}</p>
                            </div>
                        </div>
                        <div className="row mb-3">
                            <div className="col-md-6">
                                <label className="form-label fw-semibold">5. Agreement with competency up-gradation needs</label>
                                <p className="form-control bg-light" style={{ minHeight: '42px', height: 'auto', whiteSpace: 'pre-wrap', wordBreak: 'break-word' }}>{reportingAssessment.agree_competency_needs || <span className="text-muted fst-italic">Not filled</span>}</p>
                            </div>
                        </div>
                    </div>
                )}

                {/* Section 2: KPI Task Grades */}
                <h5 className="fw-bold border-bottom pb-2 mb-3">Assessment of Achievements against Targets</h5>
                <div className="table-responsive mb-4">
                    <table className="table table-bordered table-sm align-middle">
                        <thead className="table-light">
                            <tr>
                                <th style={{ width: '40%' }}>Particulars</th>
                                <th style={{ width: '15%' }}>Weightage (a)</th>
                                <th style={{ width: '20%' }}>Absolute Grade (b)</th>
                                <th style={{ width: '25%' }}>Weighted Grade (c = a x b/10)</th>
                            </tr>
                        </thead>
                        <tbody>
                            <tr className="table-secondary">
                                <td colSpan={4} className="fw-semibold">I - MoU Targets</td>
                            </tr>
                            {isMouApplicable ? (
                                <tr>
                                    <td>
                                        <div className="d-flex align-items-center gap-2">
                                            <span className="text-muted fw-semibold" style={{ minWidth: '36px' }}>*)</span>
                                            <span>{this.state.mouTaskDescription || ''}</span>
                                        </div>
                                    </td>
                                    <td className="text-center">{this.state.mouWeightage || ''}</td>
                                    <td className="text-center">{mouGradeVal || '-'}</td>
                                    <td className="text-center">{mouWeightedGrade > 0 ? mouWeightedGrade.toFixed(2) : '-'}</td>
                                </tr>
                            ) : (
                                <tr><td colSpan={4} className="text-muted fst-italic ps-3 small">MoU not applicable</td></tr>
                            )}

                            <tr className="table-secondary">
                                <td colSpan={4} className="fw-semibold">II - Other Key Assigned Tasks flowing from KPI</td>
                            </tr>
                            {tasksWithGrades.length === 0 ? (
                                <tr><td colSpan={4} className="text-muted fst-italic ps-3 small">No tasks available.</td></tr>
                            ) : (
                                tasksWithGrades.map((task: any) => (
                                    <tr key={task.id}>
                                        <td>
                                            <div className="d-flex align-items-center gap-2">
                                                <span className="text-muted fw-semibold" style={{ minWidth: '36px' }}>{task.particular}</span>
                                                <span>{task.taskDescription || ''}</span>
                                            </div>
                                        </td>
                                        <td className="text-center">{task.weightage || ''}</td>
                                        <td className="text-center">{task.absoluteGrade || '-'}</td>
                                        <td className="text-center">{task.weightedGrade > 0 ? task.weightedGrade.toFixed(2) : '-'}</td>
                                    </tr>
                                ))
                            )}
                            <tr className="table-light fw-semibold">
                                <td className="text-end pe-3">Total</td>
                                <td></td><td></td>
                                <td className="text-center">{tasksTotal > 0 ? tasksTotal.toFixed(2) : '-'}</td>
                            </tr>
                            <tr className="table-secondary fw-bold">
                                <td className="text-end pe-3">Grand Total I & II</td>
                                <td className="text-center">75</td><td></td>
                                <td className="text-center">{grandTotal > 0 ? grandTotal.toFixed(2) : '-'}</td>
                            </tr>
                        </tbody>
                    </table>
                </div>

                {/* Section 3: Personal Attributes */}
                <h5 className="fw-bold border-bottom pb-2 mb-3">Assessment of Personal Attributes <small className="text-muted fw-normal">(Weightage: 25%)</small></h5>
                <div className="table-responsive mb-4">
                    <table className="table table-bordered table-sm align-middle">
                        <thead className="table-light">
                            <tr>
                                <th style={{ width: '10%' }}>S.No.</th>
                                <th style={{ width: '60%' }}>Personal Attributes</th>
                                <th style={{ width: '30%' }}>Grade</th>
                            </tr>
                        </thead>
                        <tbody>
                            {personalAttributeMasters.map((m: any, idx: number) => {
                                const g = attrGradeMap[m.id];
                                return (
                                    <tr key={m.id}>
                                        <td>{ROMAN[idx] || idx + 1}</td>
                                        <td>{m.attribute_name}</td>
                                        <td className="text-center">{g ? g.grade : '-'}</td>
                                    </tr>
                                );
                            })}
                            <tr className="table-light fw-semibold">
                                <td colSpan={2} className="text-end pe-3">Total</td>
                                <td className="text-center">{attrTotal > 0 ? attrTotal.toFixed(2) : '-'}</td>
                            </tr>
                            <tr className="table-secondary fw-bold">
                                <td colSpan={2} className="text-end pe-3">Overall Grading (Total / 4)</td>
                                <td className="text-center">{attrTotal > 0 ? (attrTotal / 4).toFixed(2) : '-'}</td>
                            </tr>
                        </tbody>
                    </table>
                </div>

                {/* Section 4: Integrity & Pen Picture */}
                {reportingAssessment && (
                    <div className="mb-4">
                        <div className="row mb-3">
                            <div className="col-md-6">
                                <h5 className="fw-bold border-bottom pb-2 mb-3">Integrity</h5>
                                <p className="form-control bg-light" style={{ minHeight: '42px', height: 'auto', whiteSpace: 'pre-wrap', wordBreak: 'break-word' }}>{INTEGRITY_LABELS[reportingAssessment.integrity] || reportingAssessment.integrity || <span className="text-muted fst-italic">Not filled</span>}</p>
                            </div>
                            {(reportingAssessment.overall_grade !== undefined && reportingAssessment.overall_grade !== null) && (
                                <div className="col-md-6">
                                    <h5 className="fw-bold border-bottom pb-2 mb-3">Overall Grade</h5>
                                    <div className="d-flex align-items-center gap-3">
                                        <span className="fw-bold fs-4">{parseFloat(reportingAssessment.overall_grade).toFixed(2)}</span>
                                        <span className="text-muted">/ 100</span>
                                    </div>
                                    {(reportingAssessment.kpi_total || reportingAssessment.attr_total) && (
                                        <div className="small text-muted mt-1">
                                            {reportingAssessment.kpi_total && <span className="me-3">KPI Total: {parseFloat(reportingAssessment.kpi_total).toFixed(2)}</span>}
                                            {reportingAssessment.attr_total && <span>Attributes Total: {parseFloat(reportingAssessment.attr_total).toFixed(2)}</span>}
                                        </div>
                                    )}
                                </div>
                            )}
                        </div>

                        <h5 className="fw-bold border-bottom pb-2 mb-3">Pen Picture by Reporting Officer</h5>
                        <p className="form-control bg-light" style={{ minHeight: '80px', height: 'auto', whiteSpace: 'pre-wrap', wordBreak: 'break-word' }}>{reportingAssessment.pen_picture || <span className="text-muted fst-italic">Not filled</span>}</p>
                    </div>
                )}

                {!reportingAssessment && !this.state.showLoader && (
                    <div className="alert alert-warning">Reporting Manager has not submitted the assessment yet.</div>
                )}
            </div>
        );
    };

    // ── Render: Reviewing Manager View ──
    renderReviewingView = () => {
        const { reviewingAssessment, reviewingKpiGrades, reviewingAttrGrades, personalAttributeMasters, otherKeyTasks, isMouApplicable } = this.state;

        const revGradeMap = this.buildGradeMap(reviewingKpiGrades);
        const revAttrMap = this.buildAttrGradeMap(reviewingAttrGrades);

        // MoU grade lookup
        const mouGrade = this.state.mouTaskId ? revGradeMap[this.state.mouTaskId] : null;
        const mouGradeVal = mouGrade ? parseFloat(mouGrade.absolute_grade) || 0 : 0;
        const mouWeightedGrade = mouGrade ? parseFloat(mouGrade.weighted_grade) || 0 : 0;

        const tasksWithGrades = otherKeyTasks.map((t: any) => {
            const vg = revGradeMap[t.id];
            return {
                ...t,
                revGrade: vg ? String(vg.absolute_grade || '') : '',
                revWeighted: vg ? parseFloat(vg.weighted_grade) || 0 : 0,
            };
        });

        const revTotal = mouWeightedGrade + tasksWithGrades.reduce((s: number, t: any) => s + t.revWeighted, 0);
        const revAttrTotal = personalAttributeMasters.reduce((s: number, m: any) => s + (revAttrMap[m.id] ? parseFloat(revAttrMap[m.id].grade) || 0 : 0), 0);

        return (
            <div>
                {/* KPI Grades - Reviewing Only */}
                <h5 className="fw-bold border-bottom pb-2 mb-3">Assessment of Achievements against Targets</h5>
                <div className="table-responsive mb-4">
                    <table className="table table-bordered table-sm align-middle">
                        <thead className="table-light">
                            <tr>
                                <th style={{ width: '40%' }}>Particulars</th>
                                <th style={{ width: '15%' }} className="text-center">Weightage (a)</th>
                                <th style={{ width: '20%' }} className="text-center">Absolute Grade (b)</th>
                                <th style={{ width: '25%' }} className="text-center">Weighted Grade (c = a x b/10)</th>
                            </tr>
                        </thead>
                        <tbody>
                            <tr className="table-secondary"><td colSpan={4} className="fw-semibold">I - MoU Targets</td></tr>
                            {isMouApplicable ? (
                                <tr>
                                    <td>
                                        <div className="d-flex align-items-center gap-2">
                                            <span className="text-muted fw-semibold" style={{ minWidth: '36px' }}>*)</span>
                                            <span>{this.state.mouTaskDescription || ''}</span>
                                        </div>
                                    </td>
                                    <td className="text-center">{this.state.mouWeightage || ''}</td>
                                    <td className="text-center">{mouGradeVal || '-'}</td>
                                    <td className="text-center">{mouWeightedGrade > 0 ? mouWeightedGrade.toFixed(2) : '-'}</td>
                                </tr>
                            ) : (
                                <tr><td colSpan={4} className="text-muted fst-italic ps-3 small">MoU not applicable</td></tr>
                            )}
                            <tr className="table-secondary"><td colSpan={4} className="fw-semibold">II - Other Key Assigned Tasks</td></tr>
                            {tasksWithGrades.map((t: any) => (
                                <tr key={t.id}>
                                    <td>
                                        <div className="d-flex align-items-center gap-2">
                                            <span className="text-muted fw-semibold" style={{ minWidth: '36px' }}>{t.particular}</span>
                                            <span>{t.taskDescription || ''}</span>
                                        </div>
                                    </td>
                                    <td className="text-center">{t.weightage || ''}</td>
                                    <td className="text-center">{t.revGrade || '-'}</td>
                                    <td className="text-center">{t.revWeighted > 0 ? t.revWeighted.toFixed(2) : '-'}</td>
                                </tr>
                            ))}
                            <tr className="table-light fw-semibold">
                                <td className="text-end pe-3">Total</td>
                                <td></td><td></td>
                                <td className="text-center">{revTotal > 0 ? revTotal.toFixed(2) : '-'}</td>
                            </tr>
                            <tr className="table-secondary fw-bold">
                                <td className="text-end pe-3">Grand Total I & II</td>
                                <td className="text-center">75</td><td></td>
                                <td className="text-center">{revTotal > 0 ? revTotal.toFixed(2) : '-'}</td>
                            </tr>
                        </tbody>
                    </table>
                </div>

                {/* Personal Attributes - Reviewing Only */}
                <h5 className="fw-bold border-bottom pb-2 mb-3">Assessment of Personal Attributes <small className="text-muted fw-normal">(Weightage: 25%)</small></h5>
                <div className="table-responsive mb-4">
                    <table className="table table-bordered table-sm align-middle">
                        <thead className="table-light">
                            <tr>
                                <th style={{ width: '10%' }}>S.No.</th>
                                <th style={{ width: '60%' }}>Personal Attributes</th>
                                <th style={{ width: '30%' }} className="text-center">Grade</th>
                            </tr>
                        </thead>
                        <tbody>
                            {personalAttributeMasters.map((m: any, idx: number) => (
                                <tr key={m.id}>
                                    <td>{ROMAN[idx] || idx + 1}</td>
                                    <td>{m.attribute_name}</td>
                                    <td className="text-center">{revAttrMap[m.id]?.grade || '-'}</td>
                                </tr>
                            ))}
                            <tr className="table-light fw-semibold">
                                <td colSpan={2} className="text-end pe-3">Total</td>
                                <td className="text-center">{revAttrTotal > 0 ? revAttrTotal.toFixed(2) : '-'}</td>
                            </tr>
                            <tr className="table-secondary fw-bold">
                                <td colSpan={2} className="text-end pe-3">Overall Grading (Total / 4)</td>
                                <td className="text-center">{revAttrTotal > 0 ? (revAttrTotal / 4).toFixed(2) : '-'}</td>
                            </tr>
                        </tbody>
                    </table>
                </div>

                {/* Review Assessment */}
                {reviewingAssessment && (
                    <div className="mb-4">
                        <h5 className="fw-bold border-bottom pb-2 mb-3">Review by the Reviewing Authority</h5>
                        <div className="row mb-3">
                            <div className="col-md-6">
                                <label className="form-label fw-semibold">Agreement with Reporting Authority's assessment</label>
                                <p className="form-control bg-light" style={{ minHeight: '42px', height: 'auto', whiteSpace: 'pre-wrap', wordBreak: 'break-word' }}>
                                    {reviewingAssessment.agree_with_reporting !== undefined
                                        ? (reviewingAssessment.agree_with_reporting ? 'Yes' : 'No')
                                        : <span className="text-muted fst-italic">Not filled</span>}
                                </p>
                            </div>
                            <div className="col-md-6">
                                <label className="form-label fw-semibold">Difference of opinion details</label>
                                <p className="form-control bg-light" style={{ minHeight: '42px', height: 'auto', whiteSpace: 'pre-wrap', wordBreak: 'break-word' }}>{reviewingAssessment.difference_details || <span className="text-muted fst-italic">Not filled</span>}</p>
                            </div>
                        </div>
                        <div className="row mb-3">
                            <div className="col-md-12">
                                <label className="form-label fw-semibold">Comments on pen picture</label>
                                <p className="form-control bg-light" style={{ minHeight: '80px', height: 'auto', whiteSpace: 'pre-wrap', wordBreak: 'break-word' }}>{reviewingAssessment.pen_picture_comment || <span className="text-muted fst-italic">Not filled</span>}</p>
                            </div>
                        </div>
                        {reviewingAssessment.overall_grade !== undefined && reviewingAssessment.overall_grade !== null && (
                            <div className="mt-3">
                                <label className="form-label fw-semibold">Overall Grade</label>
                                <div className="d-flex align-items-center gap-3">
                                    <span className="fw-bold fs-4">{parseFloat(reviewingAssessment.overall_grade).toFixed(2)}</span>
                                    <span className="text-muted">/ 100</span>
                                </div>
                            </div>
                        )}
                    </div>
                )}

                {!reviewingAssessment && !this.state.showLoader && (
                    <div className="alert alert-warning">Reviewing Manager has not submitted the assessment yet.</div>
                )}
            </div>
        );
    };

    // ── Render: Accepting Authority View ──
    renderAcceptingView = () => {
        const { acceptingAssessment, reportingKpiGrades, reviewingKpiGrades, reportingAttrGrades, reviewingAttrGrades, personalAttributeMasters, otherKeyTasks, isMouApplicable } = this.state;

        const repGradeMap = this.buildGradeMap(reportingKpiGrades);
        const revGradeMap = this.buildGradeMap(reviewingKpiGrades);
        const repAttrMap = this.buildAttrGradeMap(reportingAttrGrades);
        const revAttrMap = this.buildAttrGradeMap(reviewingAttrGrades);

        // MoU grade lookup
        const repMouGrade = this.state.mouTaskId ? repGradeMap[this.state.mouTaskId] : null;
        const repMouGradeVal = repMouGrade ? parseFloat(repMouGrade.absolute_grade) || 0 : 0;
        const repMouWeighted = repMouGrade ? parseFloat(repMouGrade.weighted_grade) || 0 : 0;
        const revMouGrade = this.state.mouTaskId ? revGradeMap[this.state.mouTaskId] : null;
        const revMouGradeVal = revMouGrade ? parseFloat(revMouGrade.absolute_grade) || 0 : 0;
        const revMouWeighted = revMouGrade ? parseFloat(revMouGrade.weighted_grade) || 0 : 0;

        const tasksWithGrades = otherKeyTasks.map((t: any) => {
            const rg = repGradeMap[t.id];
            const vg = revGradeMap[t.id];
            return {
                ...t,
                repGrade: rg ? String(rg.absolute_grade || '') : '',
                repWeighted: rg ? parseFloat(rg.weighted_grade) || 0 : 0,
                revGrade: vg ? String(vg.absolute_grade || '') : '',
                revWeighted: vg ? parseFloat(vg.weighted_grade) || 0 : 0,
            };
        });

        const repTotal = repMouWeighted + tasksWithGrades.reduce((s: number, t: any) => s + t.repWeighted, 0);
        const revTotal = revMouWeighted + tasksWithGrades.reduce((s: number, t: any) => s + t.revWeighted, 0);
        const repAttrTotal = personalAttributeMasters.reduce((s: number, m: any) => s + (repAttrMap[m.id] ? parseFloat(repAttrMap[m.id].grade) || 0 : 0), 0);
        const revAttrTotal = personalAttributeMasters.reduce((s: number, m: any) => s + (revAttrMap[m.id] ? parseFloat(revAttrMap[m.id].grade) || 0 : 0), 0);

        const acceptData = acceptingAssessment?.acceptingAssessment || acceptingAssessment;

        return (
            <div>
                {/* KPI Grades */}
                <h5 className="fw-bold border-bottom pb-2 mb-3">Assessment of Achievements <small className="text-muted fw-normal">(Weightage: 75%)</small></h5>
                <div className="table-responsive mb-4">
                    <table className="table table-bordered table-sm align-middle" style={{ tableLayout: 'fixed' }}>
                        <thead className="table-light">
                            <tr>
                                <th rowSpan={2} style={{ width: '30%' }}>Particulars</th>
                                <th rowSpan={2} style={{ width: '10%' }} className="text-center">Weightage</th>
                                <th colSpan={2} className="text-center">Reporting Authority</th>
                                <th colSpan={2} className="text-center">Reviewing Authority</th>
                            </tr>
                            <tr>
                                <th className="text-center">Grade</th><th className="text-center">Weighted</th>
                                <th className="text-center">Grade</th><th className="text-center">Weighted</th>
                            </tr>
                        </thead>
                        <tbody>
                            <tr className="table-secondary"><td colSpan={6} className="fw-semibold">I - MoU Targets</td></tr>
                            {isMouApplicable ? (
                                <tr>
                                    <td style={{ wordBreak: 'break-word' }}>
                                        <div className="d-flex align-items-center gap-2">
                                            <span className="text-muted fw-semibold" style={{ minWidth: '36px' }}>*)</span>
                                            <span>{this.state.mouTaskDescription || ''}</span>
                                        </div>
                                    </td>
                                    <td className="text-center">{this.state.mouWeightage}</td>
                                    <td className="text-center">{repMouGradeVal || '-'}</td>
                                    <td className="text-center">{repMouWeighted > 0 ? repMouWeighted.toFixed(2) : '-'}</td>
                                    <td className="text-center">{revMouGradeVal || '-'}</td>
                                    <td className="text-center">{revMouWeighted > 0 ? revMouWeighted.toFixed(2) : '-'}</td>
                                </tr>
                            ) : (
                                <tr><td colSpan={6} className="text-muted fst-italic ps-3 small">MoU not applicable</td></tr>
                            )}
                            <tr className="table-secondary"><td colSpan={6} className="fw-semibold">II - Other Key Assigned Tasks</td></tr>
                            {tasksWithGrades.map((t: any) => (
                                <tr key={t.id}>
                                    <td style={{ wordBreak: 'break-word' }}>
                                        <div className="d-flex align-items-center gap-2">
                                            <span className="text-muted fw-semibold" style={{ minWidth: '36px' }}>{t.particular}</span>
                                            <span>{t.taskDescription || ''}</span>
                                        </div>
                                    </td>
                                    <td className="text-center">{t.weightage || ''}</td>
                                    <td className="text-center">{t.repGrade || '-'}</td>
                                    <td className="text-center">{t.repWeighted > 0 ? t.repWeighted.toFixed(2) : '-'}</td>
                                    <td className="text-center">{t.revGrade || '-'}</td>
                                    <td className="text-center">{t.revWeighted > 0 ? t.revWeighted.toFixed(2) : '-'}</td>
                                </tr>
                            ))}
                            <tr className="table-light fw-semibold">
                                <td className="text-end pe-3">Total</td><td></td><td></td>
                                <td className="text-center">{repTotal > 0 ? repTotal.toFixed(2) : '-'}</td><td></td>
                                <td className="text-center">{revTotal > 0 ? revTotal.toFixed(2) : '-'}</td>
                            </tr>
                            <tr className="table-secondary fw-bold">
                                <td className="text-end pe-3">Grand Total</td><td className="text-center">75</td><td></td>
                                <td className="text-center">{repTotal > 0 ? repTotal.toFixed(2) : '-'}</td><td></td>
                                <td className="text-center">{revTotal > 0 ? revTotal.toFixed(2) : '-'}</td>
                            </tr>
                        </tbody>
                    </table>
                </div>

                {/* Personal Attributes */}
                <h5 className="fw-bold border-bottom pb-2 mb-3">Personal Attributes <small className="text-muted fw-normal">(Weightage: 25%)</small></h5>
                <div className="table-responsive mb-4">
                    <table className="table table-bordered table-sm align-middle">
                        <thead className="table-light">
                            <tr>
                                <th style={{ width: '8%' }}>S.No.</th>
                                <th style={{ width: '42%' }}>Personal Attributes</th>
                                <th className="text-center">Reporting Authority</th>
                                <th className="text-center">Reviewing Authority</th>
                            </tr>
                        </thead>
                        <tbody>
                            {personalAttributeMasters.map((m: any, idx: number) => (
                                <tr key={m.id}>
                                    <td>{ROMAN[idx] || idx + 1}</td>
                                    <td>{m.attribute_name}</td>
                                    <td className="text-center">{repAttrMap[m.id]?.grade || '-'}</td>
                                    <td className="text-center">{revAttrMap[m.id]?.grade || '-'}</td>
                                </tr>
                            ))}
                            <tr className="table-light fw-semibold">
                                <td colSpan={2} className="text-end pe-3">Total</td>
                                <td className="text-center">{repAttrTotal > 0 ? repAttrTotal.toFixed(2) : '-'}</td>
                                <td className="text-center">{revAttrTotal > 0 ? revAttrTotal.toFixed(2) : '-'}</td>
                            </tr>
                            <tr className="table-secondary fw-bold">
                                <td colSpan={2} className="text-end pe-3">Overall Grading (Total / 4)</td>
                                <td className="text-center">{repAttrTotal > 0 ? (repAttrTotal / 4).toFixed(2) : '-'}</td>
                                <td className="text-center">{revAttrTotal > 0 ? (revAttrTotal / 4).toFixed(2) : '-'}</td>
                            </tr>
                        </tbody>
                    </table>
                </div>

                {/* Acceptance Assessment */}
                {acceptData && (acceptData.id || acceptData.kpi_report_id) && (
                    <div className="mb-4">
                        <h5 className="fw-bold border-bottom pb-2 mb-3">Acceptance Authority Assessment</h5>
                        <div className="row mb-3">
                            <div className="col-md-6">
                                <label className="form-label fw-semibold">1. Is the overall grade consistent with the pen picture?</label>
                                <p className="form-control bg-light" style={{ minHeight: '42px', height: 'auto', whiteSpace: 'pre-wrap', wordBreak: 'break-word' }}>
                                    {acceptData.is_grade_consistent !== undefined
                                        ? (acceptData.is_grade_consistent ? 'Yes' : 'No')
                                        : <span className="text-muted fst-italic">Not filled</span>}
                                </p>
                            </div>
                            <div className="col-md-6">
                                <label className="form-label fw-semibold">2. Agreement with remarks of Reporting/Reviewing Authorities</label>
                                <p className="form-control bg-light" style={{ minHeight: '42px', height: 'auto', whiteSpace: 'pre-wrap', wordBreak: 'break-word' }}>
                                    {acceptData.agree_with_authorities !== undefined
                                        ? (acceptData.agree_with_authorities ? 'Yes' : 'No')
                                        : <span className="text-muted fst-italic">Not filled</span>}
                                </p>
                            </div>
                        </div>
                        <div className="row mb-3">
                            <div className="col-md-12">
                                <label className="form-label fw-semibold">3. Difference of opinion details</label>
                                <p className="form-control bg-light" style={{ minHeight: '42px', height: 'auto', whiteSpace: 'pre-wrap', wordBreak: 'break-word' }}>{acceptData.difference_details || <span className="text-muted fst-italic">Not filled</span>}</p>
                            </div>
                        </div>
                        <div className="row mb-3">
                            {acceptingAssessment?.reviewingOverallGrade !== undefined && acceptingAssessment?.reviewingOverallGrade !== null && (
                                <div className="col-md-6">
                                    <label className="form-label fw-semibold">Reviewing Authority Overall Grade</label>
                                    <div className="d-flex align-items-center gap-3">
                                        <span className="fw-bold fs-5">{parseFloat(acceptingAssessment.reviewingOverallGrade).toFixed(2)}</span>
                                        <span className="text-muted">/ 100</span>
                                    </div>
                                </div>
                            )}
                            {acceptData.overall_grade !== undefined && acceptData.overall_grade !== null && (
                                <div className="col-md-6">
                                    <label className="form-label fw-semibold">Accepting Authority Overall Grade</label>
                                    <div className="d-flex align-items-center gap-3">
                                        <span className="fw-bold fs-4">{parseFloat(acceptData.overall_grade).toFixed(2)}</span>
                                        <span className="text-muted">/ 100</span>
                                    </div>
                                </div>
                            )}
                        </div>
                    </div>
                )}

                {(!acceptData || (!acceptData.id && !acceptData.kpi_report_id)) && !this.state.showLoader && (
                    <div className="alert alert-warning">Accepting Authority has not submitted the assessment yet.</div>
                )}
            </div>
        );
    };

    // ── Render: HR KPI Report (read-only view) ──
    renderHrView = () => {
        const { otherKeyTasks, isMouApplicable, mouTaskDescription, mouWeightage, mouDeliverables, mouAchievement } = this.state;

        const totalWeightage = this.getTotalWeightage();
        const grandTotal = this.getGrandTotal();

        return (
            <div>
                <div className="d-flex justify-content-between align-items-center mb-2">
                    <h5 className="mb-0">
                        <i className="fa fa-tasks text-primary mr-2" />
                        Annual Work Plan and Achievement
                    </h5>
                </div>

                <div className="table-responsive mb-2">
                    <table className="table table-bordered table-sm align-middle">
                        <thead className="table-light">
                            <tr>
                                <th style={{ width: '35%' }}>Tasks to be Performed</th>
                                <th style={{ width: '10%' }}>Weightage</th>
                                <th style={{ width: '25%' }}>Deliverables</th>
                                <th style={{ width: '25%' }}>Achievement</th>
                            </tr>
                        </thead>
                        <tbody>
                            <tr className="table-secondary">
                                <td colSpan={4} className="fw-semibold">
                                    I - MoU Targets
                                    {isMouApplicable && mouWeightage && (
                                        <span className="text-muted fw-normal ms-2 small">(Weightage: {mouWeightage}%, Max: 20%)</span>
                                    )}
                                </td>
                            </tr>

                            {isMouApplicable ? (
                                <tr>
                                    <td>
                                        <div className="d-flex align-items-center gap-2">
                                            <span className="text-muted fw-semibold" style={{ minWidth: '36px' }}>*)</span>
                                            <span>{mouTaskDescription || <span className="text-muted fst-italic">-</span>}</span>
                                        </div>
                                    </td>
                                    <td className="text-center">{mouWeightage || '-'}</td>
                                    <td>{mouDeliverables || <span className="text-muted fst-italic">-</span>}</td>
                                    <td>{mouAchievement || <span className="text-muted fst-italic">-</span>}</td>
                                </tr>
                            ) : (
                                <tr><td colSpan={4} className="text-muted fst-italic ps-3 small">MoU not applicable</td></tr>
                            )}

                            <tr className="table-secondary">
                                <td colSpan={4} className="fw-semibold">
                                    II - Other Key Assigned Tasks flowing from KPI
                                    <span className="text-muted fw-normal ms-2 small">(Max Weightage: {isMouApplicable ? 55 : 75}%)</span>
                                </td>
                            </tr>

                            {otherKeyTasks.map((task: any) => (
                                <tr key={task.id}>
                                    <td>
                                        <div className="d-flex align-items-center gap-2">
                                            <span className="text-muted fw-semibold" style={{ minWidth: '36px' }}>{task.particular}</span>
                                            <span>{task.taskDescription || <span className="text-muted fst-italic">-</span>}</span>
                                        </div>
                                    </td>
                                    <td className="text-center">{task.weightage || '-'}</td>
                                    <td>{task.deliverables || <span className="text-muted fst-italic">-</span>}</td>
                                    <td>{task.achievement || <span className="text-muted fst-italic">-</span>}</td>
                                </tr>
                            ))}

                            <tr className="table-light fw-semibold">
                                <td className="text-end pe-3">Total ({ROMAN_LABELS[0]} to {ROMAN_LABELS[otherKeyTasks.length - 1]})</td>
                                <td className="text-center">{totalWeightage > 0 ? totalWeightage.toFixed(0) : ''}</td>
                                <td></td><td></td>
                            </tr>
                            <tr className="table-secondary fw-bold">
                                <td className="text-end pe-3"><span className="me-2">III</span> Grand Total</td>
                                <td className="text-center">{grandTotal}</td>
                                <td></td><td></td>
                            </tr>
                        </tbody>
                    </table>
                </div>

                <div className="alert alert-light border mb-4 small">
                    <strong>Declaration:</strong> I hereby declare that the information furnished above is true to the best of my knowledge and belief.
                </div>

                <div className="d-flex justify-content-end gap-2">
                    <button type="button" className="btn btn-outline-secondary" onClick={() => this.props.history.goBack()}>Back</button>
                </div>
            </div>
        );
    };

    render() {
        const { showLoader, type, employeeCode, employeeNumber, selectedRecord, isMouApplicable, kpiReportId } = this.state;
        const typeInfo = TYPE_LABELS[type] || {};
        const selectedCycle = selectedRecord?.cycle;

        return (
            <div className="container-fluid px-4 py-3">
                <div className="row">
                    <div className="col-md-12">
                        <div className="card">
                            <div className="card-body p-4">

                                <div className="row mb-4 align-items-center">
                                    <div className="col-md-8">
                                        <h1 className="page-title mb-2">
                                            <i className={`fa ${typeInfo.icon} ${typeInfo.color} mr-2`} />
                                            {typeInfo.label} {type === 'hr' ? '— Report Form' : '— View Report'}
                                        </h1>
                                        {selectedRecord && (
                                            <p className="text-muted mb-1">
                                                <strong>{selectedCycle?.cycle_name || selectedCycle?.financial_year}</strong>
                                                &nbsp;·&nbsp;
                                                {formatDateDDMMYY(selectedRecord.startDate)}{selectedRecord.endDate ? ` to ${formatDateDDMMYY(selectedRecord.endDate)}` : ' onwards'}
                                                &nbsp;·&nbsp;
                                                <span className={`badge ${selectedRecord.isOriginal ? 'badge-success' : 'badge-warning'}`}>
                                                    {selectedRecord.periodType}
                                                </span>
                                            </p>
                                        )}
                                        <p className="text-muted mb-0">
                                            Employee Number: <strong>{employeeNumber}</strong>
                                            {isMouApplicable && <span className="badge badge-info ml-2">MoU Applicable</span>}
                                            {kpiReportId && <span className="badge badge-success ml-2">Report Exists</span>}
                                        </p>
                                    </div>
                                    <div className="col-md-4 text-right">
                                        <button type="button" className="btn btn-sm cancel-button" onClick={() => this.props.history.goBack()}>
                                            <i className="fa fa-arrow-left mr-2" />Back to Periods
                                        </button>
                                    </div>
                                </div>

                                {showLoader && <Loader />}

                                {!showLoader && type === 'hr' && this.renderHrView()}
                                {!showLoader && type === 'reporting' && this.renderReportingView()}
                                {!showLoader && type === 'reviewing' && this.renderReviewingView()}
                                {!showLoader && type === 'accepting' && this.renderAcceptingView()}

                            </div>
                        </div>
                    </div>
                </div>
            </div>
        );
    }
}

export default withRouter(HrReportDetail);
